import { circularProgressClasses } from '@mui/material/CircularProgress';

const COLORS = ['primary', 'secondary', 'info', 'success', 'warning', 'error'];

export function circularProgress(theme) {
  const rootStyles = ownerState => {
    const defaultStyle = {
      [`& .${circularProgressClasses.circle}`]: {
        strokeLinecap: 'round',
      },
    };

    const colorStyle = COLORS.map(color => ({
      ...(ownerState.color === color && {
        backgroundColor: theme.palette.background.primaryWhite1,
      }),
    }));

    return [defaultStyle, ...colorStyle];
  };
  return {
    MuiCircularProgress: {
      styleOverrides: {
        root: ({ ownerState }) => rootStyles(ownerState),
      },
    },
  };
}
